import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

export const canActivateDashboardAccessGuard = (_route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isSuperOrPartnerAdmin()) {
    return router.parseUrl('/administration/management/customers');
  }

  return true;
};
